<template>
    <!-- Navbar dropdowns -->
    <!-- <b-nav-item-dropdown text="Bitacora" v-show="rol_id == 1 || rol_id == 2 || rol_id == 3" left> -->
         <b-nav-item-dropdown text="Bitacoras" v-show="isOK == true" left>   
            <b-dropdown-group id="dropdown-group-1" header="Producción">
                <b-dropdown-item exact to="/home/guillotina">Guillotina</b-dropdown-item> 
                <b-dropdown-item exact to="/home/bitacoracd74">CD 74</b-dropdown-item>
                <b-dropdown-item exact to="/home/bobst106">TroqN106</b-dropdown-item>
                <b-dropdown-item exact to="/home/bittroqueladora3">Troq Heidelberg</b-dropdown-item>
                <b-dropdown-item exact to="/home/bittroqueladoran1">Troq N1</b-dropdown-item>
                <b-dropdown-item exact to="/home/bitpegadora">Pegadora</b-dropdown-item>
                <b-dropdown-item exact to="/home/cierreordenfabricacion">Cierre OF</b-dropdown-item>
            </b-dropdown-group>
            <b-dropdown-group id="dropdown-group-2" header="Reporte">
                <b-dropdown-item exact to="/home/filtroporof">Filtro por OF</b-dropdown-item>    
            </b-dropdown-group>
    </b-nav-item-dropdown>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    export default {
        mixins : [customMixin],
        data: function(){
            return {
                isOK: false
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']),   
        },
        methods:{
            ...mapActions({
                _fetchPermisos: 'permiso/fetchPermisosUsuarios',
            }),
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    this.isOK =  this.isBitacora(this.permiso) 
                })
            },
        }//end methods         
    }
</script>

<style lang="scss" scoped>

</style>